"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Select_1 = __importDefault(require("../Select"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var MenuItem_1 = __importDefault(require("../MenuItem"));
var colors_1 = require("../ThemeProvider/colors");
var Container = (0, styles_1.styled)('div')({
    maxWidth: '572px',
    display: 'flex',
    alignItems: 'center',
    height: '40px',
    gap: '16px',
    '@media screen and (max-width: 646px)': {
        display: 'initial',
    },
});
var MenuItemSm = (0, styles_1.styled)(MenuItem_1.default)({
    '&.MuiButtonBase-root.Mui-selected': {
        color: '#0060E0',
        backgroundColor: '#DEEBFC',
    },
    '& .MuiListItemIcon-root': {
        color: '#0060E0',
    },
});
var StyledPagination = (0, styles_1.styled)(material_1.Pagination)({
    '& .MuiPaginationItem-page': {
        color: colors_1.tannerGray['600'],
    },
    '& .MuiPaginationItem-ellipsis': {
        color: colors_1.tannerGray['600'],
    },
    '& .Mui-selected': {
        color: colors_1.tannerBlack,
    },
    '& .MuiButtonBase-root': {
        padding: '0px',
        margin: '0px',
        width: '40px',
        height: '40px',
        fontSize: '14px',
        borderRadius: '20px',
    },
    '@media screen and (max-width: 646px)': {
        size: 'small',
        paddingTop: '6px',
    },
});
var Pagination = function (_a) {
    var rowsPerPage = _a.rowsPerPage, totalRecord = _a.totalRecord, itemsPerPageOptions = _a.itemsPerPageOptions, menuProps = _a.menuProps, onChange = _a.onChange, itemsPerPage = _a.itemsPerPage, onItemsPerPageChange = _a.onItemsPerPageChange, props = __rest(_a, ["rowsPerPage", "totalRecord", "itemsPerPageOptions", "menuProps", "onChange", "itemsPerPage", "onItemsPerPageChange"]);
    var handleItemsPerPageChange = function (e) {
        var newValue = e.target.value;
        if (onItemsPerPageChange) {
            onItemsPerPageChange(newValue);
        }
    };
    return (react_1.default.createElement(Container, null,
        rowsPerPage && (react_1.default.createElement(Select_1.default, { sx: {
                minWidth: 200,
                radius: '3px',
                gap: '8px',
                '& .MuiSelect-select': { color: colors_1.tannerGray['600'] },
            }, value: itemsPerPage, onChange: handleItemsPerPageChange }, itemsPerPageOptions === null || itemsPerPageOptions === void 0 ? void 0 : itemsPerPageOptions.map(function (option) { return (react_1.default.createElement(MenuItemSm, { key: option, value: option }, "".concat(option, " ").concat(menuProps === null || menuProps === void 0 ? void 0 : menuProps.value))); }))),
        react_1.default.createElement(StyledPagination, __assign({ onChange: onChange, count: totalRecord && itemsPerPage
                ? Math.ceil(totalRecord / itemsPerPage)
                : 0 }, props))));
};
exports.default = Pagination;
//# sourceMappingURL=Pagination.js.map